<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Partner</h4>
        </div>
    </div>

    <div class="row marginBottom2Rem desktopView ">
        <div class="col-sm-3 " [formGroup]="filterForm">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Nach Partnern suchen</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen..">
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select [formControl]="this.filterForm.controls.filterState" multiple>
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterState.value != null ">
                            {{this.filterForm.controls.filterState.value | translateFilterBusinessentity :
                            'filterState'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterState.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterState.value.length - 1 }}
                            {{this.filterForm.controls.filterState.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of sortOptionsState"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-12 marginBottom2Rem">
            <button mat-button mat-raised-button color="accent" (click)="filterBusinessentity()" >
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFitler()"  style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>
    <div class="row" class="desktopView">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="Nummer">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;">
                            {{i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Logo">
                        <th mat-header-cell *matHeaderCellDef style="padding: 0 24px;">
                            Logo
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <img src="{{element?.links[1]?.href}}" class="partner_logo" alt=""
                                *ngIf="element?.links[1]?.href">
                            <mat-icon *ngIf="!element?.links[1]?.href" class="partner_logo">broken_image</mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="mat-column-contact">
                            Name
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="Adresse">
                        <th mat-header-cell *matHeaderCellDef>
                            Adresse
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.address?.street}} {{element.address?.city}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Kontaktdaten">
                        <th mat-header-cell *matHeaderCellDef class="mat-column-contact">
                            Kontaktdaten
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngFor="let contactChannel of element.contactChannels">
                                <span *ngIf="contactChannel.channelType == 'WEBSITE'">
                                    <a href="https://{{contactChannel.channelData}}" target="_blank">
                                        {{contactChannel.channelData}}
                                    </a>
                                </span>
                                <span *ngIf="contactChannel.channelType == 'PHONE_PRIVATE'">
                                    <a href="tel:{{contactChannel.channelData}}" target="_blank">
                                        {{contactChannel.channelData}}
                                    </a>
                                </span>
                                <span *ngIf="contactChannel.channelType == 'PHONE_MOBILE'">
                                    <a href="tel:{{contactChannel.channelData}}" target="_blank">
                                        {{contactChannel.channelData}}
                                    </a>
                                </span>
                                <span *ngIf="contactChannel.channelType == 'EMAIL'">
                                    <a href="mailto:{{contactChannel.channelData}}" target="_blank">
                                        {{contactChannel.channelData}}
                                    </a>
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef class="mat-column-state">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip  class="primaryChip" color="primary" selected *ngIf="element.state == 'ACTIVE' ">
                                    {{element.state | translateState}}
                                </mat-chip>
                                <mat-chip disabled *ngIf="element.state != 'ACTIVE' ">
                                    {{element.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                (click)="$event.stopPropagation()" color="accent"
                                >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item (click)="openStateChangeBottomSheet(element)">
                                    <span>Status ändern</span>
                                </button>
                                <button mat-menu-item (click)="delete(element)">
                                    <span>Partner löschen</span>
                                </button>

                                <button mat-menu-item [routerLink]="['members', element.publicId]">
                                    <span>Mitarbeiter verwalten</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                    </tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                    Einträge
                    gefunden...</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered  mat-elevation-z2"
                    [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)" [showFirstLastButtons]="true"
                    [pageSizeOptions]="[12, 24, 36, 48]" *ngIf="page" >
                </mat-paginator>
            </div>
        </div>
    </div>

    <div class="row" class="mobileView">
        <div class="col-sm-12" *ngFor="let item of this.allBusinessEntityResources">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <div mat-card-avatar *ngIf="item?.links[1] != undefined">
                        <img class="example-header-image" src='{{item?.links[1]?.href}}' alt="">
                    </div>
                    <div mat-card-avatar *ngIf="item?.links[1] == undefined">
                        <img class="example-header-image" src="../../../../../assets/placeholders/logo.svg" alt="">
                    </div>
                    <mat-card-title-group>
                        <mat-card-title>{{item.name | truncate: 15 : true}}</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <button mat-icon-button class="margintopNegative16" [matMenuTriggerFor]="menu" color="accent"
                        >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item [routerLink]="['edit', item.publicId]">
                            <span>Bearbeiten</span>
                        </button>
                        <button mat-menu-item (click)="openStateChangeBottomSheet(item)">
                            <span>Status ändern</span>
                        </button>
                        <button mat-menu-item (click)="delete(item)">
                            <span>Partner deaktivieren</span>
                        </button>

                        <button mat-menu-item [routerLink]="['members', item.publicId]">
                            <span>Mitarbeiter verwalten</span>
                        </button>
                    </mat-menu>
                </mat-card-header>

                <mat-card-content style="margin: 0 !important;">
                    <table class="contactTable">
                        <tr>
                            <td><b>{{item.name}} </b></td>
                        </tr>
                        <tr>
                            <td><b>{{item?.address?.street}} {{item?.address?.postcode}} {{item?.address?.city}}</b>
                            </td>
                        </tr>
                    </table>
                    <table class="contactTable">
                        <tr *ngFor="let contactChannel of item.contactChannels">
                            <td>
                                <p style="margin: 0;">
                                    <span *ngIf="contactChannel.channelType == 'WEBSITE'">
                                        <a href="https://{{contactChannel.channelData}}" target="_blank"
                                            (click)="$event.stopPropagation()">
                                            {{contactChannel.channelData}}
                                        </a>
                                    </span>
                                    <span *ngIf="contactChannel.channelType == 'PHONE_PRIVATE'">
                                        <a href="tel:{{contactChannel.channelData}}" target="_blank"
                                            (click)="$event.stopPropagation()">
                                            {{contactChannel.channelData}}
                                        </a>
                                    </span>
                                    <span *ngIf="contactChannel.channelType == 'PHONE_MOBILE'">
                                        <a href="tel:{{contactChannel.channelData}}" target="_blank"
                                            (click)="$event.stopPropagation()">
                                            {{contactChannel.channelData}}
                                        </a>
                                    </span>
                                    <span *ngIf="contactChannel.channelType == 'EMAIL'">
                                        <a href="mailto:{{contactChannel.channelData}}" target="_blank"
                                            (click)="$event.stopPropagation()">
                                            {{contactChannel.channelData}}
                                        </a>
                                    </span>
                                </p>
                            </td>
                        </tr>
                    </table>
                </mat-card-content>
                <br>
                <mat-card-actions>
                    <button mat-button color="primary" [routerLink]="['edit', item.publicId]">Bearbeiten</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>



<div class="fabListBtnBottomRight">
    <button mat-fab color="primary" (click)="downloadReservationList()" [matTooltipPosition]="postoolTip"
        matTooltip="Aktionspartnerliste (XLS)">
        <mat-icon>table_chart</mat-icon>
    </button>
</div>

<button class="fabAddBtnBottomRight" mat-fab color="accent" [matTooltipPosition]="postoolTip"
    matTooltip="Aktionspartner anglegen" [routerLink]="['add']">
    <mat-icon>add</mat-icon>
</button>